import { useState, useRef } from "react";
import { api, formatApiError } from "../lib/api";
import { toast } from "sonner";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { CreditCard, Loader2, ShieldCheck } from "lucide-react";

const DEMO_AMOUNT = 10.0;

export default function StripeTest() {
  const [loading, setLoading] = useState(false);
  const busyRef = useRef(false);

  const pay = async () => {
    if (busyRef.current) return;
    busyRef.current = true;
    setLoading(true);
    try {
      const { data } = await api.post("/payments/create-checkout-session", {
        purpose: "demo",
        amount: DEMO_AMOUNT,
        origin_url: window.location.origin,
      });
      if (data?.checkout_url) {
        window.location.href = data.checkout_url;
      } else {
        toast.error("URL di pagamento non ricevuto");
        setLoading(false);
        busyRef.current = false;
      }
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
      setLoading(false);
      busyRef.current = false;
    }
  };

  return (
    <div>
      <header className="sticky top-14 lg:top-0 z-10 h-16 border-b border-border bg-background flex items-center px-4 lg:px-8">
        <h1 className="text-xl font-heading font-bold">Pagamento di prova</h1>
      </header>
      <div className="p-4 lg:p-8 flex justify-center">
        <Card className="rounded border-border w-full max-w-md p-7" data-testid="stripe-test-card">
          <div className="flex items-center gap-3 mb-4">
            <div className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center">
              <CreditCard className="h-5 w-5 text-primary" strokeWidth={1.5} />
            </div>
            <div>
              <h2 className="font-heading font-semibold">Pagamento di prova</h2>
              <p className="text-xs text-muted-foreground">Stripe Checkout · modalità TEST</p>
            </div>
          </div>

          <p className="text-sm text-muted-foreground mb-5">
            Pagamento dimostrativo una tantum per verificare l'integrazione Stripe. L'importo è
            stabilito dal backend e il pagamento viene gestito nella pagina di Checkout ospitata da Stripe.
          </p>

          <div className="rounded border border-border bg-secondary/40 p-4 mb-5 flex items-center justify-between">
            <span className="text-sm text-muted-foreground">Importo di prova</span>
            <span className="text-2xl font-heading font-bold" data-testid="stripe-test-amount">10,00 €</span>
          </div>

          <Button onClick={pay} disabled={loading} className="w-full font-semibold" data-testid="stripe-test-pay-btn">
            {loading ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <CreditCard className="h-4 w-4 mr-2" />}
            Procedi al pagamento
          </Button>

          <p className="text-[11px] text-muted-foreground mt-4 flex items-center gap-1.5 justify-center">
            <ShieldCheck className="h-3.5 w-3.5" /> Carta di test: 4242 4242 4242 4242 · data futura · CVC qualsiasi
          </p>
        </Card>
      </div>
    </div>
  );
}
